import axiosWithAuth from "../utils/axiosWithAuth";
import { backUrl } from "../utils/backURL";
const API_URL = backUrl;
// Get available configuration sections for a client
export const getConfigurationSections = async (clientId) => {
  try {
    const response = await axiosWithAuth.get(`${API_URL}/workflows/p2p/${clientId}/configuration/sections`)
    return response.data
  } catch (error) {
    console.error("Error getting configuration sections:", error)
    throw error
  }
}

// Get configuration options for a specific section
export const getSectionOptions = async (clientId, sectionId) => {
  try {
    const response = await axiosWithAuth.get(`${API_URL}/workflows/p2p/${clientId}/configuration/sections/${sectionId}/options`)
    return response.data
  } catch (error) {
    console.error("Error getting section options:", error)
    throw error
  }
}

// Get configuration value for a specific option
export const getOptionValue = async (clientId, sectionId, optionId) => {
  try {
    const response = await axiosWithAuth.get(`${API_URL}/workflows/p2p/${clientId}/configuration/sections/${sectionId}/options/${optionId}`)
    return response.data
  } catch (error) {
    console.error("Error getting option value:", error)
    throw error
  }
}

// Update configuration value for a specific option
export const updateOptionValue = async (clientId, sectionId, optionId, value) => {
  try {
    const response = await axiosWithAuth.put(
      `${API_URL}/workflows/p2p/${clientId}/configuration/sections/${sectionId}/options/${optionId}`,
      { value }
    )
    return response.data
  } catch (error) {
    console.error("Error updating option value:", error)
    throw error
  }
}

// Custom Inventory Columns API

// Get all custom columns for inventory
export const getCustomInventoryColumns = async (clientId) => {
  try {
    const response = await axiosWithAuth.get(`${API_URL}/workflows/p2p/${clientId}/inventory/custom-columns`)
    return response.data
  } catch (error) {
    console.error("Error getting custom inventory columns:", error)
    throw error
  }
}

// Create a new custom column for inventory
export const createCustomInventoryColumn = async (clientId, columnData) => {
  try {
    const response = await axiosWithAuth.post(`${API_URL}/workflows/p2p/${clientId}/inventory/custom-columns`, columnData)
    return response.data
  } catch (error) {
    console.error("Error creating custom inventory column:", error)
    throw error
  }
}

// Update an existing custom column for inventory
export const updateCustomInventoryColumn = async (clientId, columnId, columnData) => {
  try {
    const response = await axiosWithAuth.put(`${API_URL}/workflows/p2p/${clientId}/inventory/custom-columns/${columnId}`, columnData)
    return response.data
  } catch (error) {
    console.error("Error updating custom inventory column:", error)
    throw error
  }
}

// Delete a custom column for inventory
export const deleteCustomInventoryColumn = async (clientId, columnId) => {
  try {
    const response = await axiosWithAuth.delete(`${API_URL}/workflows/p2p/${clientId}/inventory/custom-columns/${columnId}`)
    return response.data
  } catch (error) {
    console.error("Error deleting custom inventory column:", error)
    throw error
  }
} 